import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const VivaEngageAppInbox = () => import(/* webpackChunkName: "4-feat-vivaengageappinbox" */ './VivaEngageAppInbox');
export default lazyLoadOnRender({ loader: VivaEngageAppInbox });
